import { render, staticRenderFns } from "./MerchantBusinessBankDetailsManagement.vue?vue&type=template&id=8f3c73e6&scoped=true&"
import script from "./MerchantBusinessBankDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessBankDetailsManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBusinessBankDetailsManagement.vue?vue&type=style&index=0&id=8f3c73e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3c73e6",
  null
  
)

export default component.exports